export function invoke(fn: () => void | Promise<unknown>): void {
  void fn()
}
